function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Fordypningsskjermer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "01_Menu",
  transform: "translate(-647.000000, -249.000000)",
  fill: "#F0AB00",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M658.265547,249.90338 C658.026428,249.652657 657.697972,249.507661 657.352449,249.500295 C657.006927,249.492929 656.672646,249.623796 656.423159,249.864103 L647.401452,258.554757 C647.145004,258.801692 647,259.143121 647,259.500019 C647,259.856917 647.145004,260.198346 647.401452,260.445282 L656.423159,269.135936 C656.942714,269.636298 657.76758,269.618713 658.265547,269.096659 C658.763514,268.574605 658.746014,267.745773 658.226458,267.245411 L650.187184,259.500019 L658.226458,251.754628 C658.475981,251.514358 658.620283,251.184323 658.627613,250.837139 C658.634944,250.489955 658.504703,250.154067 658.265547,249.90338 Z",
  id: "Shape",
  transform: "translate(652.813953, 259.500000) rotate(-180.000000) translate(-652.813953, -259.500000) "
})));

var SvgHoriArrow = function SvgHoriArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "21px",
    viewBox: "0 0 12 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHoriArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hori-arrow.c87268e4.svg";
export { ForwardRef as ReactComponent };